import { checkMenuShow } from '@/store/tool'

import { DirectiveBinding, VNode, createVNode, render } from 'vue'

/**
 * <div v-permission="'edit'">
 *  <div v-permission="['edit', 'view']">
 *  <div v-permission.and="['edit', 'admin']">
 */
export const PermissionDirective = {
  mounted: (
    el: Element,
    binding: { value: string | string[]; modifiers: Record<string, boolean> },
  ) => {
    const { value, modifiers } = binding
    const operator = modifiers.and ? '&&' : '||'

    if (typeof value === 'string') {
      if (!checkMenuShow(value)) {
        el.remove()
      }
    } else if (Array.isArray(value)) {
      const hasPermission =
        operator === '&&'
          ? value.every((p) => checkMenuShow(p))
          : value.some((p) => checkMenuShow(p))

      if (!hasPermission) {
        el.remove()
      }
    } else {
      console.error('permission key must be string or array')
    }
  },
}

export const PermissionRouterDirective = {
  mounted(el: HTMLElement, binding: DirectiveBinding, vnode: VNode) {
    const { value } = binding
    const hasPermission = checkMenuShow(value)
    el.innerHTML = ''
    if (hasPermission && vnode.props?.to) {
      // Ensure `to` is a valid route object or string
      const to = typeof vnode.props.to === 'object' ? { ...vnode.props.to } : vnode.props.to
      const routerLink = createVNode(
        'router-link',
        {
          to: '/home/overview',
        },
        vnode.children,
      )
      render(routerLink, el)
    } else {
      render(vnode, el)
    }
  },
}
